/**
 * Class 9 NCERT Science Chapter catalog
 * Based on the official CBSE / NCERT Class 9 Science syllabus
 */

export const CLASS_9_SCIENCE_CHAPTERS = [
  {
    id: 'matter-in-our-surroundings',
    number: 1,
    name: 'Matter In Our Surroundings',
    branch: 'Chemistry',
    branchColor: 'amber',
    description: 'Explore how matter exists in three states — solid, liquid, gas — and how temperature affects molecular motion.',
    learningGoals: [
      'States of matter and their properties',
      'Effect of temperature on molecules',
      'Melting & boiling points, evaporation',
    ],
    simulator: {
      status: 'live',
      route: '/science/class-9/matter-in-our-surroundings',
      preview: 'Interactive molecular motion simulator — drag the temperature slider and watch molecules transition between solid, liquid, and gas.',
      cta: 'Launch Simulator',
    },
  },
  {
    id: 'is-matter-around-us-pure',
    number: 2,
    name: 'Is Matter Around Us Pure',
    branch: 'Chemistry',
    branchColor: 'amber',
    description: 'Differentiate between mixtures, solutions, colloids, and pure substances. Learn separation techniques.',
    learningGoals: [
      'Mixtures vs pure substances',
      'Solutions, colloids, suspensions',
      'Separation methods (filtration, distillation)',
    ],
    simulator: {
      status: 'coming-soon',
      preview: 'Mixture-separator lab: filter sand from water, distil salt solution, perform chromatography on ink.',
      cta: 'Coming Soon',
    },
  },
  {
    id: 'atoms-and-molecules',
    number: 3,
    name: 'Atoms And Molecules',
    branch: 'Chemistry',
    branchColor: 'amber',
    description: 'Understand atoms, molecules, ions, and how they combine to form compounds. Learn molar mass calculations.',
    learningGoals: [
      'Laws of chemical combination',
      'Atomic mass, molecular mass',
      'Mole concept and stoichiometry',
    ],
    simulator: {
      status: 'coming-soon',
      preview: 'Build H2O, CO2, NaCl by dragging atoms together. Auto-calculate molar mass and balance equations.',
      cta: 'Coming Soon',
    },
  },
  {
    id: 'structure-of-the-atom',
    number: 4,
    name: 'Structure of the Atom',
    branch: 'Chemistry',
    branchColor: 'amber',
    description: "Discover atomic models from Thomson to Bohr. Learn electron configuration and isotopes.",
    learningGoals: [
      "Discovery of subatomic particles",
      "Bohr's model of atom",
      'Electron arrangement, valency',
    ],
    simulator: {
      status: 'coming-soon',
      preview: 'Animated Bohr atom builder — add protons, neutrons, electrons. See shell-filling rules in action.',
      cta: 'Coming Soon',
    },
  },
  {
    id: 'motion',
    number: 5,
    name: 'Motion',
    branch: 'Physics',
    branchColor: 'cyan',
    description: 'Master the language of motion — distance, displacement, velocity, acceleration — through interactive graphs.',
    learningGoals: [
      'Distance vs displacement',
      'Speed, velocity, acceleration',
      'Equations of motion, distance-time graphs',
    ],
    simulator: {
      status: 'live',
      route: '/science/class-9/motion',
      preview: 'Drive a virtual car along a track. Watch distance-time and velocity-time graphs draw in real-time as you accelerate or brake.',
      cta: 'Launch Simulator',
    },
  },
  {
    id: 'force-and-laws-of-motion',
    number: 6,
    name: 'Force And Laws Of Motion',
    branch: 'Physics',
    branchColor: 'cyan',
    description: "Newton's three laws of motion — inertia, F=ma, and action-reaction pairs.",
    learningGoals: [
      "Newton's first, second, third laws",
      'Inertia and momentum',
      'Friction and applied force',
    ],
    simulator: {
      status: 'coming-soon',
      preview: 'Push boxes across surfaces (ice, sand, wood). See how friction, mass, and force change motion.',
      cta: 'Coming Soon',
    },
  },
  {
    id: 'gravitation',
    number: 7,
    name: 'Gravitation',
    branch: 'Physics',
    branchColor: 'cyan',
    description: "Universal law of gravitation, free fall, and your weight on different planets.",
    learningGoals: [
      'Universal law of gravitation',
      'Free fall, acceleration due to gravity',
      'Mass vs weight, thrust and pressure',
    ],
    simulator: {
      status: 'coming-soon',
      preview: 'Drop objects from a tower on Earth, Moon, Mars, Jupiter. Compare landing times and final velocities.',
      cta: 'Coming Soon',
    },
  },
  {
    id: 'work-and-energy',
    number: 8,
    name: 'Work And Energy',
    branch: 'Physics',
    branchColor: 'cyan',
    description: 'Understand work, kinetic & potential energy, and the law of conservation of energy through a swinging pendulum.',
    learningGoals: [
      'Work done by a force',
      'Kinetic and potential energy',
      'Law of conservation of energy, power',
    ],
    simulator: {
      status: 'coming-soon',
      preview: 'Pull a pendulum to any height — watch PE convert to KE and back, with live energy bars.',
      cta: 'Coming Soon',
    },
  },
];

export const SCIENCE_CLASSES = [
  { id: 9, status: 'live', chapterCount: 8, route: '/science/class-9' },
  { id: 10, status: 'coming-soon', chapterCount: 13, route: '/science/class-10' },
  { id: 11, status: 'coming-soon', chapterCount: 15, route: '/science/class-11' },
  { id: 12, status: 'coming-soon', chapterCount: 15, route: '/science/class-12' },
];
